<template>
  <t-form :requiredMark="option.attribute.required" :labelAlign="option.attribute.labelAlign">
    <t-form-item :label="option.attribute.label" class="my_textarea" :style="setStyles">
      <t-textarea class="my_textarea_item" v-model="iptVal" :style="setStyles" :placeholder="option.attribute.placeholder"
        :size="option.attribute.size" @blur="clickHandler" @change="changeInput" :status="message"
        :tips="tips" :disabled="option.attribute.disabled" :readonly="option.attribute.readonly" :autosize="option.attribute.autosize" :maxlength="option.attribute.maxlength"/>
    </t-form-item>
  </t-form>
</template>

<script>
import {
  getDataJson,
  pollingRefresh,
  hasNonEmptyValues,
  hasProperty,
} from "@/utils/refresh-cpt-data";
import { getDefaultValue } from "@/utils/refresh-cpt-data";
// import { mixinsCom } from "@/mixins/globalAllComps";


export default {
  name: "cpt-textarea",
  props: {
    option: Object,
    refMap: Object,
    current:Object,
  },
  // mixins: [mixinsCom], 
  computed: {
    cptData() {  //组件绑定的属性
      console.log("======textres====",this.option.cptDataForm.resData);
      if(this.option.cptDataForm.resData){
          return this.processData(this.option.cptDataForm, this.option.cptDataForm.resData);
      }
    },
    setStyles() {
      return {
        "--width": this.current.cptWidth + "px",
        "--height": this.option.attribute.autosize ? '28px' : this.option.attribute.height + "px",
        "--indent": this.option.attribute.indent + "px",
        "--bgColor": this.option.attribute.bgColor,
        "--textColor": this.option.attribute.textColor,
        "--placholderColor": this.option.attribute.textPlaceholderColor,
        "--fontStyle": this.option.attribute.fontStyle,
        "--fontWeight": this.option.attribute.fontWeight,
        "--fontFamily": this.option.attribute.fontFamily,
        "--fontSize": this.option.attribute.fontSize + "px",
        "--borderSize": this.option.attribute.borderSize + "px",
        "--borderColor": this.option.attribute.borderColor,
        "--borderRadius": this.option.attribute.borderRadius + "px",
        "--lineType": this.option.attribute.lineType,
        "--labelBoolean":this.option.attribute.labelBoolean ? 'block':'none',
        "--marginLeft":this.option.attribute.labelBoolean && this.option.attribute.labelAlign  != 'top' ?  this.option.attribute.labelWidth + "px" : '0px',
        "--labelWidth": this.option.attribute.labelWidth + "px",
        "--textAlign":this.option.attribute.align,
        "--disabledColor":this.option.attribute.disabledColor
      }
    },
    dataReload(){
      return this.option.attribute.globalDataReload || [0]
    }
  },
  data() {
    return {
      uuid:null,
      iptVal: '',
      newData: "",
      jsFunFlag: false,
      message: "default",
      tips: "",
    }
  },
  watch: {
    // 'option.attribute': {
    //   handler(obj) {
    //      this.processData(this.option.cptDataForm, this.newData, this.jsFunFlag);
    //   },
    //   deep: true
    // }
    "current.cptShow"(val){
      if (val && this.dataReload.includes(1)) {
        this.refreshCptData();
      }
    },
    "option.attribute.hideCompInTab"(val){
      // 组合选项卡内显示时
      if (!val && this.dataReload.includes(1)) {
        this.refreshCptData();
      }
    }
  },
  created() {
    this.uuid = require("uuid").v1();
    // 新增属性兼容旧代码
    if (!this.option.attribute.globalDataReload) {
      this.option.attribute.globalDataReload = [0]
    }
    if (this.dataReload.includes(0)) {

        this.refreshCptData();
      
    }
  },
  methods: {
   refreshCptData(cptDataForm = this.option.cptDataForm, paras) {
      pollingRefresh(this.uuid, cptDataForm, () =>
        this.loadData(cptDataForm, paras)
      );
    },
    loadData(cptDataForm, paras) {
      const that = this;
      getDataJson(cptDataForm, paras, (res) => {
        that.newData =
          cptDataForm.dataSource == "4" && hasProperty(res, "jsFunction")
            ? res.resStr
            : res; //相同数据集只调用一次接口原因
        // that.jsFunFlag =
        //   cptDataForm.dataSource == "4" && hasProperty(res, "jsFunction")
        //     ? res.jsFunction
        //     : false; //相同数据集只调用一次接口原因
        that.processData(cptDataForm, that.newData, that.jsFunFlag);  //监听里面会执行的
      });
    },
    processData(cptDataForm, res, jsFunFlag,isFromGrid) {
      // 第一层判断 如果选择数据集
      if (cptDataForm.dataSource == "4") {
            // if(this.current.cptOption.interaction.fatherGridId && isFromGrid != 'ninegrid')return 

        // 第二层判断 ，如果没有配转换脚本
        // if (jsFunFlag) {
              //判断此控件在九宫格里面就不请求数据
          // 没有全部配置映射字段
          if (hasNonEmptyValues(this.option.attribute.cptTableData)) {
            const dataKey = this.option.attribute.cptTableData;
            let newres = [];
            let newObj = { ...res[0] };
            newObj[dataKey[0].namekey] = newObj[dataKey[0].value];
            newres.push(newObj);
           this.iptVal = newres[0].value;
          }
        // } else {
        //   // 如果配置了转换脚本
        //   this.iptVal = res.value;
        // }
      } else {
        // 不是数据集类型，是静态数据
        this.iptVal = res.value;
      }
    },
    clickHandler() {
      this.checkValue();
      this.$emit("clickHandler", this.option.interaction, 'default', this.iptVal, 'cpt-input');
    },
   
    changeInput() {
      this.checkValue();
    },
    // 校验方法
    checkValue() {
      const { attribute } = this.option;
      if (attribute.required && !this.iptVal) {
        this.setValidationMessage(false);
        return false;
      } else {
        this.setValidationMessage(true);
        return true;
      }
    },
    setValidationMessage(isValid) {
      this.message = isValid ? "default" : "error";
      this.tips = isValid ? "" : `${this.option.attribute.label}必填`;
    },
    getValue() {
      return this.iptVal
    },
    setValue(value) {
      this.iptVal = value
    },
  }
}
</script>

<style scoped>
.my_textarea /deep/ .t-form__label {
   color:var(--textColor);
   font-style: var(--fontStyle);
   font-weight: var(--fontWeight);
   font-family: var(--fontFamily);
   font-size: var(--fontSize);
   line-height: var(--height);
   display:var(--labelBoolean);
   width:var(--labelWidth) !important;
}
.t-form :deep(.t-form__controls){
  margin-left: 0px !important;
}
.my_textarea_item /deep/ .t-textarea__inner::placeholder {
   color: var(--placholderColor); 
 }

.my_textarea_item /deep/ .t-textarea__inner {
  padding-left: var(--indent);
  color: var(--textColor);
  font-style: var(--fontStyle);
  font-weight: var(--fontWeight);
  font-family: var(--fontFamily);
  font-size: var(--fontSize);
  background-color: var(--bgColor);
  border-width: var(--borderSize);
  border-color: var(--borderColor);
  border-radius: var(--borderRadius);
  border-style: var(--lineType);
  text-align: var(--textAlign);
  height: var(--height);
  min-height: var(--height);
}

.my_textarea_item /deep/.t-textarea__inner:focus {
     box-shadow: none !important;
     border-color:var(--borderColor);
}

.my_textarea_item /deep/.t-textarea__inner:hover {
     box-shadow: none !important;
     border-color:var(--borderColor);
}

.my_textarea_item /deep/.t-input--focused {
     box-shadow: none !important;
     border-color:var(--borderColor);
}

.my_input_item /deep/.t-is-focused {
     box-shadow: none !important;
     border-color:var(--borderColor);
} 

:deep(.t-textarea__inner .t-is-disabled) {
    background-color:var(--disabledColor) !important;
}

</style>